/* src/app/views/admin/user-wallet/user-wallet.component.css */
:host ::ng-deep .p-tabview-nav li.p-highlight {
  color: #0f9a8c;
  border-bottom: 5px solid #0f9a8c;
}
::ng-deep p-paginator svg {
  transform: rotate(180deg);
}
/*# sourceMappingURL=user-wallet.component.css.map */
